import { render, staticRenderFns } from "./safe-checkout.vue?vue&type=template&id=94ae355e&"
import script from "./safe-checkout.vue?vue&type=script&lang=js&"
export * from "./safe-checkout.vue?vue&type=script&lang=js&"
import style0 from "./safe-checkout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports